import React from 'react';
import { withRouter } from 'react-router-dom';

import { ratingTypes } from '../../../utils/constants';
import { sportTypeIds } from '../../../utils/eventConstants';
import { formatEventDate } from '../../../utils/formatting';
import { buildImportedEventPath, canBuildImportedEventPath } from '../../../pages/ImportedEvents/importedEventPaths';
import { ImportedEventEntryPoints } from '../../Analytics/constants';

import styles from './eventItem.scss';
import { EventTypes } from '../../../utils/clubs';

class EventHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { startDate, endDate, eventId, isTms, isDualMatch, eventName, draw, auth, isProProfile, timeZoneValue, isLeaguesMatch, sportTypeId, results = [], eventType, history, isImportedEventPagesEnabled, importedPageReady, importedEventType } = this.props;
        const userLoggedIn = auth?.user;
        const getRatingTitle = () => {
            if (sportTypeId) {
                if (sportTypeId === 1) {
                    return ratingTypes.tennis;
                }
                if (sportTypeId === 2) {
                    return ratingTypes.pickleball;
                }
            }

            const hasTennisResults = results.filter(result => result.sportTypeId === sportTypeIds.TENNIS).length > 0;
            const hasPickleballResults = results.filter(result => result.sportTypeId === sportTypeIds.PICKLEBALL).length > 0;

            if (hasTennisResults && !hasPickleballResults) {
                return ratingTypes.tennis;
            }
            if (!hasTennisResults && hasPickleballResults) {
                return ratingTypes.pickleball;
            }
            return `${ratingTypes.tennis} / ${ratingTypes.pickleball}`;
        };

        const drawKey = draw?.id ?? draw?.name;
        const drawSegment = drawKey ? `.draw-${drawKey}` : '';
        const testIdPrefix = eventId ? `result.event-${eventId}${drawSegment}` : 'result.event-item';

        const isLegacyEvent = eventType === EventTypes.LEGACY;
        const isImportedLink = isImportedEventPagesEnabled &&
            importedPageReady === true &&
            !!eventId &&
            canBuildImportedEventPath({ importedEventType, eventId });
        const shouldDisplayEventHyperlink = isImportedLink || (!!eventId && !isLegacyEvent && (isTms || isDualMatch));
        const isNavigable = shouldDisplayEventHyperlink && (isImportedLink || isTms);

        const navigateToEvent = () => {
            if (shouldDisplayEventHyperlink) {
                if (isImportedLink) {
                    // Router state, not a query param, so the entry point never reaches the
                    // Imported Event Page's copyable share URL (TMS-2221).
                    history.push({
                        pathname: buildImportedEventPath({ importedEventType, eventId }),
                        state: { entryPoint: ImportedEventEntryPoints.RESULTS_TAB_CARD },
                    });
                } else if (isTms) {
                    history.push(`/events/${eventId}`);
                }
            }
        };

        const linkA11yProps = isNavigable
            ? {
                role: 'link',
                tabIndex: 0,
                onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        if (e.key === ' ') {
                            e.preventDefault();
                        }
                        navigateToEvent();
                    }
                },
            }
            : {};

        return (
            <div className={`${styles.eventHeaderContainer}`}>
                <div className={`${styles.eventHeader}`} data-testid={`${testIdPrefix}.event-header`}>
                    <div className="row">
                        <div className={`col-7 col-md-9 ${styles.eventName}`}>
                            <span
                                className={`${shouldDisplayEventHyperlink ? 'text-teal cursor-pointer' : ''}`}
                                onClick={navigateToEvent}
                                {...linkA11yProps}
                                data-testid={`${testIdPrefix}.event-name`}
                            >
                                {eventName}
                            </span>
                            {draw?.name && (
                                <div className={`${styles.drawName}`}>
                                    <span className={`${styles.middleDot}`}>&nbsp;</span>{draw.name}
                                </div>
                            )}
                        </div>
                        <div className={`col-5 col-md-3 ${styles.eventTime}`} data-testid={`${testIdPrefix}.event-time`}>
                            {formatEventDate(startDate, endDate, timeZoneValue)}
                        </div>

                    </div>
                </div>
                <div className={`d-none d-md-block ${styles.matchHeaders}`}>
                    <div className={`d-flex flex-row`}>
                        <div className={`${styles.data}`}>
                            <div className={`d-flex flex-row ${styles.team}`}>
                                <div className={`col-4 ${styles.playerDetailsContainer}`} data-testid={`${testIdPrefix}.players-header`}>
                                    Players
                                </div>
                                <div className={`col-${isLeaguesMatch ? '2' : '4'} ${styles.utrContainer}`} data-testid={`${testIdPrefix}.rating-header`}>
                                    {(userLoggedIn || isProProfile) && getRatingTitle()}
                                </div>
                                {isLeaguesMatch && (
                                    <div className={`col-3`} data-testid={`${testIdPrefix}.team-header`}>
                                        Team
                                    </div>
                                )}
                                <div className={`col-${isLeaguesMatch ? '2' : '4'} ${styles.scoresConatiner}`} data-testid={`${testIdPrefix}.score-header`}>
                                    Score
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EventHeader);
